export default __webpack_public_path__ + "static/media/lightOn.639fcfe7.svg";